import React from 'react'

export type LegendItem = { label: string; color: string; subitems?: LegendItem[] }

export const ChartLegend: React.FC<{
  className?: string
  items: LegendItem[]
  onLabelClick?: (labels: string[]) => void
}> = ({ className = 'flex-wrap gap-2', items, onLabelClick }) => {
  return (
    <div className={`flex ${className}`}>
      {items.map((item, i) => {
        return (
          <div
            key={i}
            className={`flex ${onLabelClick ? 'cursor-pointer' : ''} items-center gap-1`}
            onClick={() => {
              onLabelClick && onLabelClick([item.label.toLowerCase()])
            }}
          >
            <div className={`h-[1em] w-[1em] rounded-full`} style={{ backgroundColor: item.color }} />
            <div>{item.label}</div>
            {item.subitems && (
              <div className="flex flex-col text-nowrap rounded border-l border-gray-500 pl-1 text-sm leading-4">
                {item.subitems.map((subitem, j) => (
                  <div
                    key={j}
                    className="flex items-center gap-1"
                    onClick={(e) => {
                      onLabelClick && onLabelClick([subitem.label.toLowerCase()])
                      e.stopPropagation()
                    }}
                  >
                    <div className={`h-3 w-3 rounded-full`} style={{ backgroundColor: subitem.color }} />
                    <div>{subitem.label}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export const DummyLegend: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`flex gap-2 ${className}`}>
    <div className="h-[1em] w-[1em] rounded-full bg-gray-200" />
    <div className="h-[1em] w-[6em] rounded bg-gray-200" />
  </div>
)
